import { MutationTree } from 'vuex';
import { VasState } from './types';

export const mutations: MutationTree<VasState> = {
  setShops(state, shops = []): VasState {
    state.shops = shops;
    return state;
  },

  setSaleType (state, { type = null }): VasState {
    state.saleType = type;
    return state;
  },

  setCurrentVAS (state, { vasId = null, shopId = null, merchantId = null  }): VasState {
    state.merchantId = merchantId
    state.vasId = vasId
    state.shopId = shopId
    return state;
  },

  setCustomerDetails (state, customer: null | CustomerDetails): VasState {
    state.customerDetails = customer;
    return state;
  },

  setShippingAddress (state, shippingAddress: null | GooglePlace): VasState {
    state.shippingAddressPlace = shippingAddress;
    return state;
  },

  setShippingTimeSlot (state, selectedTimeslot: null | TimeSlot): VasState {
    state.selectedTimeslot = selectedTimeslot;
    return state;
  },

  setShopMenu (state, shopMenu: null | MerchantShopMenu): VasState {
    state.shopMenu = shopMenu;
    return state;
  },

  setMerchantDetails (state, merchantDetails: null | MerchantDetails): VasState {
    state.merchantDetails = merchantDetails;
    return state;
  },
  setMerchantShopDetails (state, merchantShopDetails: null | MerchantShopDetails): VasState {
    state.merchantShopDetails = merchantShopDetails;
    return state;
  }
};